import { router } from "@inertiajs/react"
import { Link } from "@radix-ui/themes"
import type { ComponentProps, MouseEvent } from "react"

import { cn } from "@/lib/utils"

type LinkProps = ComponentProps<typeof Link>

export default function TextLink({ className = "", children, ...props }: LinkProps) {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    // Allow the browser to handle anything that isn't a plain left-click
    if (
      e.defaultPrevented || // already handled
      e.button !== 0 || // middle / right button
      e.metaKey ||
      e.ctrlKey || // ⌘ or Ctrl (new-tab)
      e.shiftKey ||
      e.altKey || // Shift / Alt variants
      props.target === "_blank" // explicit new-tab link
    ) {
      return
    }

    // Our own client-side navigation for a normal click
    e.preventDefault()
    if (props.href) router.visit(props.href)
  }

  return (
    <Link {...props} className={cn(className)} onClick={handleClick}>
      {children}
    </Link>
  )
}
